<template>
  <div class="col-md-5">
    <div class="text-center">
      <img
        loading="lazy"
        src="@/assets/img/logo-colored.svg"
        class="img-fluid"
        width="50"
        alt="Orange One finance Logo"
      />
      <img
        loading="lazy"
        src="@/assets/img/404.png"
        class="img-fluid"
        alt="Orange One 404 Error page"
      />

      <router-link
        class="btn orange_button py-2 px-5 text-white font-12 mt-3"
        to="/"
        >Go Home</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  layout: "error"
};
</script>
